// THIS IS THE DEFAULT VALUE YOU CAN CHANGE IF YOU WANT

const breakpoints = {
  values: {
    xs: 0,
    sm: 600,
    md: 960,
    customd: 1165,
    lg: 1280,
    xl: 1920
  }
};

export default breakpoints;
